import { Box, CircularProgress, Stack, Typography, useTheme } from '@mui/material';
import { format } from 'date-fns';
import { VigoTypography } from 'src/@vigo/vigo-typography';

interface StatusPanelHeaderProps {
  loading?: boolean;
  title?: string;
  displayDocs?: boolean;
}

const StatusPanelHeader = ({ loading = false, title, displayDocs = true }: StatusPanelHeaderProps) => {
  // Hooks
  const theme = useTheme();

  return (
    <>
      {loading && (
        <Box sx={{ padding: '30px', width: '100%', display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size="2.143rem" />
        </Box>
      )}
      {!loading && (
        <Stack
          direction="row"
          sx={{
            paddingBottom: '10px',
            pt: '5px'
          }}>
          <Box sx={{ flex: 1 }}>
            {title && title?.length > 0 ? (
              <Typography
                sx={{
                  color: theme.palette.mode === 'light' ? '#2B2D42' : '#fff',
                  fontSize: '1.2rem',
                  fontWeight: 'bold'
                }}>
                {format(new Date(title), 'eee Mo MMM (dd/MM/yy)')}
              </Typography>
            ) : (
              <VigoTypography
                sx={{
                  color: theme.palette.mode === 'light' ? '#2B2D42' : '#fff',
                  fontSize: '1.2rem',
                  fontWeight: 'bold'
                }}
                value="Status History"
              />
            )}
          </Box>

          {displayDocs && (
            <Box sx={{ width: '20%', paddingLeft: '20px' }}>
              <VigoTypography
                sx={{
                  color: theme.palette.mode === 'light' ? '#2B2D42' : '#fff',
                  fontSize: '1.2rem',
                  fontWeight: 'bold'
                }}
                value="Docs"
              />
            </Box>
          )}
        </Stack>
      )}
    </>
  );
};

export default StatusPanelHeader;
